import React from "react";

const StickyFooter = (props) => {
	return (
		<>
			{props?.showFooter && (
				<>
				{props?.showOpacityFooter && (
					<div
						style={{
							position: "fixed",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo preto com 50% de opacidade
							zIndex: 99,
							maxWidth: "480px",
							margin: "0 auto",
						}}
					/>
				)}
				<div
					style={{
						position: "fixed",
						left: 0,
						right: 0,
						bottom: 0,
						zIndex: 100,
						background: props?.backgroundNew ? "#FDFCF8" : "#fff",
						paddingBottom: "1.5%",
						margin: "0 auto",
						maxWidth: "480px",
						borderRadius: props?.showOpacityFooter ? "20px 20px 0 0": "",
						animation: props?.showOpacityFooter ? "slideUp 0.3s ease-out": "",
					}}>
					{props.children}
				</div>
				<style>{`
					@keyframes slideUp {
						from {
							transform: translateY(100%);
							opacity: 0;
						}
						to {
							transform: translateY(0);
							opacity: 1;
						}
					}
					
					@keyframes fadeIn {
						from {
							opacity: 0;
						}
						to {
							opacity: 1;
						}
					}
				`}</style>
				</>
			)}
		</>
	);
};

export default StickyFooter;
